<template>
  <div class="fixed inset-0 w-full h-full z-100">
    <div
      class="absolute inset-0 w-full h-full bg-black z-0"
      :class="$style.background"
    ></div>
    <div class="flex items-center justify-center relative z-10 w-full h-full">
      <div class="bg-white shadow flex flex-col" :style="style">
        <div v-if="$slots.header" class="p-3">
          <span class="text-xl font-normal"><slot name="header"></slot></span>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppModal',

  props: {
    width: {
      type: Number,
      default: () => 400
    },
    height: {
      type: Number,
      default: () => 200
    },
    closeButtonLabel: {
      type: String,
      default: () => 'Stäng'
    },
    confirmButtonLabel: {
      type: String,
      default: () => 'Bekräfta'
    }
  },

  computed: {
    style() {
      return {
        width: `${this.width}px`,
        minHeight: `${this.height}px`
      }
    }
  }
}
</script>

<style lang="postcss" module>
.background {
  animation: fade theme('durations.slow-2')
    theme('timingFunctions.expressive-standard') 0s normal forwards;
}

@keyframes fade {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.6;
  }
}
</style>
